import { Popover, VStack, HStack, Text, Avatar, Button, Box, Portal } from '@chakra-ui/react';
import { FiUserX } from 'react-icons/fi'
import type { RecutAvailableCanvasserDto } from '../../../types/campaign'

interface Props {
  isOpen: boolean
  onClose: () => void
  turfIndex: number
  turfLabel: string
  currentCanvasserId: string | null
  availableCanvassers: RecutAvailableCanvasserDto[]
  onAssign: (turfIndex: number, canvasserId: string | null) => void
  /** Pixel position for anchoring */
  anchorRef: React.RefObject<HTMLDivElement>
}

export function TurfAssignmentPopover({
  isOpen, onClose, turfIndex, turfLabel, currentCanvasserId,
  availableCanvassers, onAssign, anchorRef,
}: Props) {
  return (
    <Popover.Root open={isOpen} lazyMount unmountOnExit closeOnInteractOutside onOpenChange={e => {
      if (e.open)
        {} else {
        onClose();
      }
    }} positioning={{
      placement: 'right'
    }}>
      <Popover.Trigger asChild>
        <Box ref={anchorRef} position="absolute" w="1px" h="1px" pointerEvents="none" />
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content w="240px" shadow="lg">
            <Popover.Arrow />
            <Popover.Body p={3}>
              <VStack gap={2} align="stretch">
                <Text fontSize="xs" fontWeight="medium" color="gray.500">
                  Assign: {turfLabel}
                </Text>

                {availableCanvassers.map((c) => {
                  const isSelected = c.grantId === currentCanvasserId
                  return (
                    <HStack
                      key={c.grantId}
                      p={1.5}
                      borderRadius="md"
                      bg={isSelected ? 'accent.soft' : 'transparent'}
                      _hover={{ bg: isSelected ? 'accent.soft' : 'gray.50' }}
                      cursor="pointer"
                      onClick={() => {
                        onAssign(turfIndex, c.grantId)
                        onClose()
                      }}
                      gap={2}
                    >
                      {/* L11 slice 1f: canvasser is a Contact, not a User -- initials avatar, no portrait. */}
                      <Avatar.Root size="xs"><Avatar.Fallback name={c.fullName} /></Avatar.Root>
                      <Text fontSize="sm" fontWeight={isSelected ? 'medium' : 'normal'}>
                        {c.fullName}
                      </Text>
                    </HStack>
                  );
                })}

                {currentCanvasserId && (
                  <Button
                    size="xs"
                    variant="ghost"
                    colorPalette="red"
                    onClick={() => {
                      onAssign(turfIndex, null)
                      onClose()
                    }}><FiUserX />Unassign
                                    </Button>
                )}
              </VStack>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}
